import React from 'react';
import { Stack } from '@adc/parallax-component-library';
import { ThemedImage } from '../ThemedImage';
function AppLogo({ isMobileBrowser = false }) {
    return (React.createElement(Stack, { padding: isMobileBrowser ? '$4' : 40 },
        React.createElement(ThemedImage, { resourceKey: "Global.microcopy.common.libreLogoLight", alt: "", id: "Global.microcopy.common.libreLogo", style: {
                height: isMobileBrowser ? '32px' : '52px',
                objectFit: 'contain',
            } })));
}
export { AppLogo };
